var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendspeedmeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 156,
    viewBox: "0 0 310 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.82 150.666C309.898 153.282 307.769 155.405 305.152 155.405H237.163C234.546 155.405 232.44 153.281 232.283 150.668C231.64 139.935 228.827 129.806 224.298 120.689C223.137 118.351 223.898 115.469 226.157 114.16L289.155 77.6765C289.157 77.6754 289.158 77.674 289.16 77.6724C289.172 77.6603 289.192 77.663 289.201 77.6777C301.619 99.2686 309.029 124.144 309.82 150.666Z",
    fill: "url(#paint0_linear_455_498)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.167 77.649C289.176 77.6652 289.174 77.6857 289.16 77.6989C289.158 77.7015 289.155 77.7037 289.152 77.7056L226.152 114.152C223.884 115.464 220.994 114.677 219.55 112.491C213.804 103.792 206.375 96.3417 197.702 90.5801C195.527 89.1354 194.744 86.2573 196.047 83.9944L232.421 20.8006C232.423 20.7975 232.425 20.7946 232.427 20.792C232.44 20.7788 232.461 20.7761 232.477 20.7855C255.974 34.433 275.561 54.08 289.167 77.649Z",
    fill: "url(#paint1_linear_455_498)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.421 20.7532C232.436 20.7617 232.438 20.782 232.426 20.794C232.425 20.7957 232.423 20.7975 232.422 20.7994L196.063 83.9679C194.754 86.2413 191.853 87.0049 189.507 85.8312C180.429 81.2893 170.336 78.4885 159.668 77.8457C157.056 77.6883 154.932 75.582 154.932 72.965V4.73838C154.932 2.12145 157.054 -0.00748606 159.67 0.0708952C186.126 0.863655 210.899 8.27422 232.421 20.7532Z",
    fill: "url(#paint2_linear_455_498)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.193 0.0710126C152.809 -0.00749157 154.932 2.12145 154.932 4.73838V72.965C154.932 75.582 152.808 77.6882 150.196 77.8466C139.526 78.4933 129.432 81.3086 120.353 85.8401C118.008 87.0103 115.112 86.2447 113.805 83.9731L77.4674 20.7994C77.4663 20.7975 77.4649 20.7957 77.4633 20.794C77.4513 20.7819 77.4539 20.7617 77.4687 20.7532C98.9649 8.27484 123.758 0.864386 150.193 0.0710126Z",
    fill: "url(#paint3_linear_455_498)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4625 20.792C77.4651 20.7946 77.4673 20.7975 77.4691 20.8006L113.843 83.9944C115.146 86.2573 114.363 89.1354 112.188 90.5801C103.515 96.3417 96.0854 103.792 90.3397 112.491C88.8957 114.677 86.0056 115.464 83.7378 114.152L20.738 77.7056C20.7349 77.7037 20.732 77.7015 20.7294 77.6989C20.7162 77.6857 20.7135 77.6652 20.7229 77.649C34.3287 54.08 53.9156 34.433 77.4126 20.7855C77.4288 20.7761 77.4493 20.7788 77.4625 20.792Z",
    fill: "url(#paint4_linear_455_498)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7246 77.7051C20.73 77.7051 20.7354 77.7065 20.7401 77.7093L83.7267 114.187C85.9883 115.496 86.7483 118.384 85.5833 120.723C81.0438 129.839 78.2456 139.967 77.6065 150.699C77.451 153.311 75.3445 155.435 72.7276 155.435H4.73837C2.12144 155.435 -0.00741757 153.312 0.0702478 150.696C0.858495 124.148 8.24982 99.2909 20.6977 77.7206C20.7032 77.711 20.7135 77.7051 20.7246 77.7051Z",
    fill: "url(#paint5_linear_455_498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_498",
    x1: 234.237,
    y1: 141.735,
    x2: 304.309,
    y2: 114.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1576,
    stopColor: "#06A541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    stopColor: "#0FBD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7597,
    stopColor: "#14CC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16D154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_455_498",
    x1: 207.601,
    y1: 99.6689,
    x2: 263.931,
    y2: 46.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81CB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9F351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_455_498",
    x1: 173.966,
    y1: 81.4599,
    x2: 194.859,
    y2: 6.63121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#FFBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#FFD820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#FFE82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_455_498",
    x1: 136.605,
    y1: 78.6355,
    x2: 115.714,
    y2: 9.21134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2244,
    stopColor: "#FF9F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5201,
    stopColor: "#FFB921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7876,
    stopColor: "#FFC92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_455_498",
    x1: 100.989,
    y1: 102.011,
    x2: 44.6478,
    y2: 45.0721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2771,
    stopColor: "#FF6E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5535,
    stopColor: "#FF8822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8024,
    stopColor: "#FF982A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_455_498",
    x1: 83.9264,
    y1: 136.278,
    x2: 6.18385,
    y2: 115.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0460655,
    stopColor: "#FF0C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3221,
    stopColor: "#FF2F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5813,
    stopColor: "#FF4924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8147,
    stopColor: "#FF592B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendspeedmeter);
export default __webpack_public_path__ + "static/media/friendspeedmeter.e585625c5c818312ea27afcc58b99475.svg";
export { ForwardRef as ReactComponent };